'use client';

import { ClearCacheButton } from '@/components/buttons/ClearCacheButton';
import React from 'react';

export default function ClearCacheButtonClient(
  props: React.ComponentProps<typeof ClearCacheButton>
) {
  return <ClearCacheButton {...props} />;
}
